import { useFormik } from 'formik';
import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import history from 'routing/history';
import * as Yup from 'yup';
import Button, { BackButton } from 'components/Button';
import ViewAnimator from '../../components/ViewAnimator';
import { StepHeading } from '../../components/StepHeading/styled';
import { STEP_PATHS } from '../../consts';
import useNavigateToNextStep from '../../hooks/useNavigateToNextStep';
import useNextAndPrevUrl from '../../hooks/useNextAndPrevUrl';
import { addValidStep, editClaim, removeValidStep, setClaimInfo } from '../../state';
import { Field } from '../../styled';
import { ClaimHeading, FieldLabel, NavigationButtons, TextInput } from './styled';

const validation = Yup.object({
  identityNumber: Yup.string().required('Required')
});

const PersonalInformation = () => {
  const dispatch = useDispatch();
  const { claimType, step } = useParams();
  const { nextUrl, prevUrl } = useNextAndPrevUrl(claimType, step);

  const { identityNumber } = useSelector(
    (state) => state.nomadInsurance.claims.claimInfo
  );
  const { claimID, editError, isLoading } = useSelector(
    (state) => state.nomadInsurance.claims
  );
  useNavigateToNextStep(nextUrl, editError);

  const formik = useFormik({
    initialValues: useMemo(
      () => ({
        identityNumber
      }),
      [identityNumber] // eslint-disable-line
    ),
    onSubmit: async (editedInfo) => {
      if (claimID) {
        await dispatch(editClaim({ claimID, editedInfo }));
      } else {
        await dispatch(setClaimInfo(editedInfo));
        history.push(nextUrl);
      }
    },
    validateOnMount: true,
    validationSchema: validation
  });

  useEffect(() => {
    if (formik.isValid) {
      dispatch(addValidStep(STEP_PATHS.PERSONAL_INFORMATION));
    } else {
      dispatch(removeValidStep(STEP_PATHS.PERSONAL_INFORMATION));
    }
  }, [formik.isValid, dispatch]);

  return (
    <ViewAnimator>
      <StepHeading>Personal Information</StepHeading>
      <ClaimHeading>Claimant's personal information</ClaimHeading>
      <div>
        <Field>
          <FieldLabel>Passport number or national identification number</FieldLabel>
          <TextInput formik={formik} name="identityNumber" />
        </Field>
        <NavigationButtons>
          <BackButton
            onClick={() => {
              history.push(prevUrl);
            }}
            variant="dark"
          >
            Back
          </BackButton>
          <Button
            onClick={() => formik.submitForm()}
            disabled={!formik.isValid || isLoading}
          >
            Save & next
          </Button>
        </NavigationButtons>
      </div>
    </ViewAnimator>
  );
};

export default PersonalInformation;
